import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "quick-search__wrap" }
const _hoisted_2 = { class: "quick-search__input-wrap" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row py-5" }
const _hoisted_6 = { class: "col-md-6 mb-4 mb-md-0" }
const _hoisted_7 = { class: "h5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-hover" }, null, -1 /* HOISTED */)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "col-md-6 quick-search__panel-border" }
const _hoisted_13 = { class: "h5 quick-search__products-heading" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-hover" }, null, -1 /* HOISTED */)
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PagesSearchCard = _resolveComponent("PagesSearchCard")!
  const _component_ProductsSearchCard = _resolveComponent("ProductsSearchCard")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref: "searchInput",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        type: "text",
        placeholder: _ctx.translations?.TypeToSearch,
        class: "secondary-nav__search-input quick-search__input",
        tabindex: "8",
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.queryTheTerm && $options.queryTheTerm(...args))),
        onKeypress: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.searchProducts && $options.searchProducts(...args)))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3), [
        [_vModelText, _ctx.searchTerm]
      ]),
      _createElementVNode("button", {
        ref: "searchButton",
        class: "icon-search secondary-nav__search-button quick-search__button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.queryTheTerm && $options.queryTheTerm(...args))),
        "aria-label": "Search Icon",
        title: "Search"
      }, null, 512 /* NEED_PATCH */)
    ]),
    (_ctx.searchTerm)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "quick-search__search-panel",
          style: _normalizeStyle(`top: ${_ctx.headerHeight}`),
          ref: "searchPanel"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.translations?.Pages), 1 /* TEXT */),
                (_ctx.pages.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createCommentVNode(" Card for each page result "),
                          _createVNode(_component_PagesSearchCard, {
                            url: page.url,
                            contentType: page.contentType,
                            kicker: page.contentTypeDisplay,
                            title: page.highlightResults.title.value
                          }, null, 8 /* PROPS */, ["url", "contentType", "kicker", "title"])
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      _createElementVNode("a", {
                        href: `/search?FilterCriteria.Query=${_ctx.searchTerm}&FilterCriteria.Tab=pages`,
                        class: "quick-search__view-all"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.translations?.ViewAllMatchingPages) + " ", 1 /* TEXT */),
                        _hoisted_10
                      ], 8 /* PROPS */, _hoisted_9)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.translations?.NoPagesFound), 1 /* TEXT */)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.translations?.Products), 1 /* TEXT */),
                (_ctx.products.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createCommentVNode(" Card for each product result "),
                          _createVNode(_component_ProductsSearchCard, {
                            url: product.url,
                            name: product.displayName,
                            translations: _ctx.translations,
                            primaryImageUrl: product.primaryImageUrl,
                            stockNumber: product.highlightResults?.stockNumber?.value,
                            displayName: product.highlightResults?.displayName?.value,
                            additionalDisplayName: product.highlightResults?.additionalDisplayName?.value
                          }, null, 8 /* PROPS */, ["url", "name", "translations", "primaryImageUrl", "stockNumber", "displayName", "additionalDisplayName"])
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      _createElementVNode("a", {
                        href: `/search?FilterCriteria.Query=${_ctx.searchTerm}&FilterCriteria.Tab=products`,
                        class: "quick-search__view-all"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.translations?.ViewAllMatchingProducts) + " ", 1 /* TEXT */),
                        _hoisted_16
                      ], 8 /* PROPS */, _hoisted_15)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.translations?.NoProductsFound), 1 /* TEXT */)
                    ]))
              ])
            ])
          ])
        ], 4 /* STYLE */)), [
          [_directive_click_outside, $options.onClickOutside]
        ])
      : _createCommentVNode("v-if", true)
  ]))
}